import styled from 'styled-components';
import React, { useEffect, useState } from 'react';
import { COLORS, SIZES, Typography } from '@fupa/fupa-uikit';
import queryString from 'query-string';
import { useLocation } from 'react-router';
const Wrapper = styled.div.withConfig({
  componentId: "sc-1xhn711-0"
})(["position:fixed;top:", ";margin:auto;padding:", ";height:", ";border-radius:", ";background-color:", ";opacity:0.8;line-height:", ";cursor:pointer;"], SIZES['80'], SIZES['8'], SIZES['36'], SIZES['18'], COLORS.black, SIZES['20']);
const WhiteText = styled(Typography).withConfig({
  componentId: "sc-1xhn711-1"
})(["&&&{color:", ";}"], COLORS.white);
export default function LoadCurrentDataButton() {
  const location = useLocation();
  const searchQuery = queryString.parse(location.search);
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (searchQuery.page) {
      setShow(true);
    }
  }, []);
  const handleClick = () => {
    setShow(false);
    window.location.href = location.pathname;
  };
  return show ? /*#__PURE__*/React.createElement(Wrapper, {
    onClick: handleClick,
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "LoadCurrentDataButton",
    "data-sentry-source-file": "LoadCurrentDataButton.tsx"
  }, /*#__PURE__*/React.createElement(WhiteText, {
    variant: "body1",
    "data-sentry-element": "WhiteText",
    "data-sentry-source-file": "LoadCurrentDataButton.tsx"
  }, "Aktuelle Meldungen anzeigen")) : null;
}